<section class="stepper">
  <header>
    <ol class="stepper__steps">
      @for (step of steps; track step; let i = $index) {
        <a (click)="selectedIndex = i"
          [attr.aria-label]="(i+1) + ' of ' + steps.length + ' ' + ariaLabelText"
          >
          <div class="stepper__step_wrapper">
            <li
              class="stepper__step"
              [ngClass]="selectedIndex === i ? activeClass : ''"
              [class.completed]="step.completed"
              >
              @if (step.stepLabel) {
                <ng-container
                  [ngTemplateOutlet]="step.stepLabel.template"
                  >
                </ng-container>
              } @else {
                {{ step.label }}
              }
            </li>
            @if (steps.length !== i + 1) {
              <div
                class="stepper__divider"
              ></div>
            }
          </div>
        </a>
      }
    </ol>
  </header>

  <div class="stepper__body">
    <ng-container [ngTemplateOutlet]="selected?.content"></ng-container>
  </div>
</section>
